import React from 'react';
import _ from 'lodash';
import FilterCheckbox from '../../../components/FilterCheckbox/FilterCheckbox';
import FilterLabel from '../../../components/FilterLabel/FilterLabel';
import FilterDelimiter from '../../../components/FilterDelimiter/FilterDelimiter';
import phraseTypes from '../../../../const/phraseTypes';
import {
    PHRASE_FILTER,
    PATTERNHASH_FILTER,
    ENTITY_TYPE_FILTER,
    ENTITY_VALUE_FILTER,
    DIALOG_FILTER,
    OUTPUT_PHRASES,
    INPUT_PHRASES,
    UNRECOGNIZED_PHRASES,
} from '../../../../const/logFilters';
import getColorByText from '../../../../services/mini/getColorByText';

class AnalyticIntentsVariableFilters extends React.Component {

    getEntityFilterLabel = (entity) => {
        const filterParts = entity[Object.keys(entity)[0]].split('_');
        if (filterParts.length > 1) {
            return <span className="filter-label-entity" style={{ backgroundColor: `${getColorByText(filterParts[0], .8)}` }}>{filterParts[1]} {filterParts[0]}</span>;
        }
        return <span className="filter-label-entity" style={{ backgroundColor: `${getColorByText(filterParts[0], .8)}` }}>{filterParts[0]}</span>;
    }

    render() {
        const {
            environment,
            filters,
            hasFilterByPhrases,
            resetPhraseTextFilter,
            resetPatternFilter,
            resetDialogFilter,
            resetEntityFilter,
            resetAllPhrasesFilters,
        } = this.props;

        const filtersCount = (filters[PHRASE_FILTER] && 1) + (filters[PATTERNHASH_FILTER] && 1) + (filters[DIALOG_FILTER] && 1) + filters.entities.length;
        const showResetAllBtn = filtersCount > 1;

        return (
            <div className={`analytic-intents-filters ${environment}`}>
                {hasFilterByPhrases && <div className="analytic-intents-filters_dynamic-filters">

                    <div className="analytic-intents-filters_dynamic-filters_header">
                        <div className="analytic-intents-filters_label">Filters</div>
                    </div>

                    <div className="analytic-intents-filters_dynamic-filters_body">
                        {filters[PHRASE_FILTER] && <FilterLabel title="Phrase" onReset={resetPhraseTextFilter} />}

                        {filters[PATTERNHASH_FILTER] && <FilterLabel title="Pattern" onReset={resetPatternFilter} />}

                        {filters[DIALOG_FILTER] && <FilterLabel title="Dialog" onReset={resetDialogFilter} />}

                        {filters.entities.map((entity, ind) => {
                            return <FilterLabel key={ind} title={this.getEntityFilterLabel(entity)} entity={entity} onReset={resetEntityFilter} />;
                        })}

                        {showResetAllBtn && <span className="error-panel_reset-all-filters" onClick={resetAllPhrasesFilters}>Reset Filters <i className="icon icon-alan-remove-fat" /></span>}
                    </div>
                </div>}
            </div>
        );
    }
}


export default AnalyticIntentsVariableFilters;
